import { FieldProps } from "../../../../reusable_components/input_fields/Input";

export const handleChange = (
  elements: FieldProps[],
  setElements: React.Dispatch<React.SetStateAction<FieldProps[]>>,
  field_id: string,
  event: any
) => {
  const newElements = elements.map((field) => {
    if (field_id === field.id) {
      if (field.type === "file") {
        field.value = event[0];
      } else {
        field.value = event.target.value;
      }
    }
    return field;
  });
  setElements(newElements);
};
